// extracted by mini-css-extract-plugin
module.exports = {"toolboxToolbarContainer":"Toolbar_toolboxToolbarContainer__bTWXZ","toolboxToolbar":"Toolbar_toolboxToolbar__XCMaJ","MaterialIcon":"Toolbar_MaterialIcon__MgDiQ"};